(function(){
  if (window.__bbQuickShopInit) return;
  window.__bbQuickShopInit = true;

  var SECTION = 'bb-quickshop';

  /* GA4: harmless no-ops when no dataLayer/gtag is present */
  function track(name, params){
    try {
      var p = params || {};
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, p));
      if (typeof window.gtag === 'function') window.gtag('event', name, p);
    } catch (e) {}
  }


  var root, body, cache = {}, lastTrigger = null, inflight = null;
  var navList = [], navIndex = -1, currentUrl = null;

  function shell(){
    if (root) return root;
    root = document.querySelector('[data-bb-qs]');
    if (!root) return null;
    /* The product grid is a CSS container (container-type:inline-size), which
       would become the containing block for this fixed drawer. Moving it to
       <body> once, on init, keeps it anchored to the viewport — and puts the
       .quick-product-modal root where Massy's `body .quick-product-modal`
       selector can see it. */
    if (root.parentNode !== document.body) document.body.appendChild(root);
    root.removeAttribute('hidden');
    body = root.querySelector('[data-bb-qs-body]');
    return root;
  }

  function skeleton(){
    return '<div class="bb-qs__loading"><i class="col"></i><div class="pane">' +
           '<i class="r" style="width:64%;height:20px"></i><i class="r" style="width:30%"></i>' +
           '<i class="r" style="width:100%;height:172px"></i>' +
           '<i class="r" style="width:76%"></i><i class="r" style="width:100%;height:52px"></i></div></div>';
  }

  function sectionUrl(productUrl){
    return productUrl + (productUrl.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + SECTION;
  }

  function load(productUrl){
    if (cache[productUrl]) return Promise.resolve(cache[productUrl]);
    return fetch(sectionUrl(productUrl))
      .then(function(r){ if(!r.ok) throw new Error('quickshop ' + r.status); return r.text(); })
      .then(function(html){ cache[productUrl] = html; return html; });
  }

  function open(productUrl, trigger){
    if (!shell()) return;
    lastTrigger = trigger || null;
    currentUrl = productUrl;
    /* prev/next walks the triggers as they appear on this page */
    navList = [].map.call(document.querySelectorAll('[data-bb-qs-open]'), function(t){
      return t.getAttribute('data-bb-qs-open');
    }).filter(function(u, i, a){ return a.indexOf(u) === i; });
    navIndex = navList.indexOf(productUrl);
    syncNav();
    track('bb_quickshop_open', { product_handle: (productUrl.split('/').pop() || '').split('?')[0] });
    var token = (inflight = {});
    body.innerHTML = cache[productUrl] || skeleton();
    /* injected DOM: bb-saved.js only paints heart state on load and on
       bb:saved:change, so a cached/prefetched panel replays a stale heart */
    if (window.BBSaved) window.BBSaved.repaint();
    root.classList.add('is-open');
    if (cache[productUrl]) { hydrate(); bbWhenMassyReady(repriceWithMassy); }
    document.documentElement.classList.add('bb-qs-lock');
    root.querySelector('.bb-qs__panel').focus();
    load(productUrl).then(function(html){
      if (inflight !== token || !root.classList.contains('is-open')) return;
      body.innerHTML = html;
      if (window.BBSaved) window.BBSaved.repaint();
      hydrate();
      bbWhenMassyReady(repriceWithMassy);
    }).catch(function(){
      if (inflight !== token) return;
      window.location = productUrl;   /* worst case, the product page still works */
    });
  }

  function close(restoreFocus){
    if (!root) return;
    inflight = null;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('bb-qs-lock');
    /* Restore focus to the card trigger ONLY for keyboard closes (Escape).
       The trigger's reveal rule also fires on :focus-within, so refocusing
       after a mouse close left the "Quick Shop" bar lit on the old card
       while the shopper hovered a different one. Mouse closes let focus
       fall away naturally; keyboard users keep their place. */
    if (restoreFocus && lastTrigger){
      var lt = lastTrigger;
      /* deferred: same-dispatch listeners (focus traps) override an
         immediate focus() */
      setTimeout(function(){ lt.focus(); }, 0);
    }
    lastTrigger = null;
    setTimeout(function(){ if (root && !root.classList.contains('is-open')) body.innerHTML = ''; }, 340);
  }

  function syncNav(){
    if (!root) return;
    var prev = root.querySelector('[data-bb-qs-prev]');
    var next = root.querySelector('[data-bb-qs-next]');
    var many = navList.length > 1 && navIndex > -1;
    if (prev) prev.hidden = !(many && navIndex > 0);
    if (next) next.hidden = !(many && navIndex < navList.length - 1);
  }

  function goNav(dir){
    if (navIndex < 0) return;
    var i = navIndex + dir;
    if (i < 0 || i >= navList.length) return;
    /* keep the original trigger for focus return on close */
    var keep = lastTrigger;
    open(navList[i], keep);
  }

  /* ---- hydration: everything the injected HTML cannot do for itself ------
     Section markup arrives via innerHTML, so its <script> tags would never
     run. Delivery dates and the origin map are wired up here instead. */
  function hydrate(){
    syncDots();
    delivery();
    wholesale();
    mountGlobe();
  }

  /* Same business-day arithmetic as the product page's delivery block. */
  var HOLIDAYS = [
    '2026-05-25','2026-06-19','2026-07-03','2026-09-07',
    '2026-10-12','2026-11-11','2026-11-26','2026-11-27','2026-12-25',
    '2027-01-01','2027-01-18','2027-02-15','2027-05-31',
    '2027-06-18','2027-07-05','2027-09-06','2027-10-11',
    '2027-11-11','2027-11-25','2027-11-26','2027-12-24'
  ];
  function toISO(d){
    return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
  }
  function isBusinessDay(d){
    var dow = d.getDay();
    if (dow === 0 || dow === 6) return false;
    return HOLIDAYS.indexOf(toISO(d)) === -1;
  }
  function addBusinessDays(start, n){
    var d = new Date(start), c = 0;
    while (c < n){ d.setDate(d.getDate()+1); if (isBusinessDay(d)) c++; }
    return d;
  }
  function formatDate(d){
    var m = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return m[d.getMonth()] + ' ' + d.getDate();
  }
  function delivery(){
    var el = body.querySelector('[data-bb-qs-delivery]');
    if (!el) return;
    var us = el.getAttribute('data-mode') === 'us';
    var min = us ? 2 : 3, max = us ? 8 : 15;
    var now = new Date();
    var dates = el.querySelector('[data-bb-qs-dates]');
    /* 2026-10-05: dates come from window.bbDelivery (snippets/bb-delivery-engine.liquid,
       Theme settings > BB · Shipping and Delivery) so the drawer matches the product page
       and the cart, including the away window. International uses the product page's DHL
       offsets (3 to 9, Canada 3 to 6). The arithmetic below is only the fallback. */
    var bbd = window.bbDelivery, text = '';
    if (bbd) {
      try {
        var ca = window.Shopify && Shopify.country === 'CA';
        text = us ? bbd.range('auto').text : bbd.offsets(3, ca ? 6 : 9).text;
      } catch (e) { text = ''; }
    }
    if (!text) text = formatDate(addBusinessDays(now,min)) + ' to ' + formatDate(addBusinessDays(now,max));
    if (dates) dates.textContent = text;
    var rate = el.querySelector('[data-bb-qs-rate]');
    if (rate) rate.innerHTML = us
      ? '$8.99 flat rate shipping &middot; <em>Free over $99</em>'
      : 'International shipping, duties and taxes all calculated at checkout';
  }

  /* ---- wholesale tiers ----------------------------------------------------
     Display-only rendering of Massy's own rule data (MassyInitData), so a
     wholesale login sees its tiers inside the drawer just like the PDP.
     Massy's fetch patch still applies the real pricing at add time — this
     paints numbers, it never computes a charge. Everything is guarded: if
     Massy's packed format ever changes, the block stays hidden and the
     drawer simply shows retail. Eligibility = customer tag matches the
     rule's applyCustomerTags (tags come from Liquid on the shell) AND the
     product is not in an excluded collection. */
  function massyRule(){
    try {
      var mid = window.MassyInitData;
      if (!mid || !mid.pricingRules || !mid.pricingRules[0] || !mid.pricingRules[1]) return null;
      var names = mid.pricingRules[0], secs = mid.pricingRules[1];
      function sec(n){
        var i = names.indexOf(n);
        var sd = i > -1 ? secs[i] : null;
        if (!sd || !sd[0] || !sd[0].length) return [];
        var keys = sd[0], flat = sd[1], out = [];
        for (var j = 0; j + keys.length <= flat.length; j += keys.length){
          var o = {};
          for (var k = 0; k < keys.length; k++) o[keys[k]] = flat[j + k];
          out.push(o);
        }
        return out;
      }
      var rules = sec('pricingRules');
      if (!rules.length) return null;
      var rule = rules[0];
      var tiers = sec('customPricings').filter(function(t){ return t.ruleId === rule.id; })
        .sort(function(a,b){ return a.quantityFrom - b.quantityFrom; });
      if (!tiers.length) return null;
      return {
        rule: rule,
        tiers: tiers,
        tags: sec('applyCustomerTags').filter(function(t){ return t.ruleId === rule.id; })
          .map(function(t){ return String(t.name).toLowerCase(); }),
        exCids: sec('excludeCollections').filter(function(t){ return t.ruleId === rule.id; })
          .map(function(t){ return String(t.sCollectionId); })
      };
    } catch (e){ return null; }
  }

  function moneyFmt(n){
    var neg = n < 0 ? '-' : '';
    n = Math.abs(n);
    var whole = Math.floor(n);
    var cents = Math.round((n - whole) * 100);
    if (cents === 100){ whole++; cents = 0; }
    var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return neg + '$' + w + (cents ? '.' + String(cents).padStart(2, '0') : (n % 1 ? '.00' : ''));
  }

  /* 2026-09-09: Quick Shop prints retail (variant.price in Liquid). For a
     wholesale buyer whose bag has already reached a tier, ask Massy's own engine
     for each variant's unit price and show it, retail struck through. The three
     guards mirror assets/bb-cart.js: the server rendered the wholesale strip,
     the strip says a tier is active ("You're at N% off"), and getPrice returned
     a number strictly below retail. Rewriting data-price on each size button is
     deliberate: the existing click handler copies data-price into the headline
     and the Add to Bag button, so variant changes stay at wholesale on their own. */
  /* 2026-09-09: Massy's loader boots async. Measured on the live store,
     window.Massy.getPrice only exists several seconds after DOMContentLoaded,
     which is AFTER the drawer paints its rows. The first version returned
     silently when Massy was missing and never retried, so a wholesale buyer saw
     retail every time. Poll for up to 12s, then give up quietly and leave retail. */
  function bbWhenMassyReady(cb, tries) {
    tries = (typeof tries === 'number') ? tries : 48;
    if (window.Massy && typeof window.Massy.getPrice === 'function') { cb(); return; }
    if (tries <= 0) return;
    setTimeout(function () { bbWhenMassyReady(cb, tries - 1); }, 250);
  }

  /* 2026-09-10: THE reason every reprice below looked like it did nothing.
     Massy's tiers are SPEND bands, not quantity bands. In its own rules payload
     they are stored as quantityFrom/quantityTo = 150 / 300 / 1000, and
     Massy.getPrice(variantId, N) passes N straight into applyPricingRule, which
     picks a band with `quantityFrom <= N`. We were passing 1. 150 <= 1 is false,
     so no band ever matched, no discount was ever applied, and getPrice returned
     the retail price to every caller, for every customer, at every bag size.
     Verified 2026-09-10 by reading Massy's own bundle (745-7b32c25a.js,
     applyPricingRule / getTotalQuantity) and by calling getPrice on the live
     storefront: a $45.00 variant returns 45, i.e. SHOP-CURRENCY DOLLARS.
     The correct second argument is the gross bag total in shop currency, which
     is what Massy's getTotalQuantity computes for an ENTIRE_ORDER spend rule:
     the sum of line prices BEFORE any discount, including lines that are
     themselves excluded from the discount. original_line_price is presentment,
     so divide by Shopify.currency.rate to get back to shop currency. */
  var bbGrossCache = { at: 0, p: null };
  function bbGrossBagDollars() {
    var now = Date.now();
    if (bbGrossCache.p && (now - bbGrossCache.at) < 1500) return bbGrossCache.p;
    bbGrossCache.at = now;
    bbGrossCache.p = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var rate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1') || 1;
        if (!(rate > 0)) rate = 1;
        var cents = (c.items || []).reduce(function (t, it) {
          return t + (typeof it.original_line_price === 'number' ? it.original_line_price : (it.price || 0) * (it.quantity || 0));
        }, 0);
        return cents / 100 / rate;
      })
      .catch(function () { return 0; });
    return bbGrossCache.p;
  }

  function repriceWithMassy(){
    var strip0 = document.getElementById('bb-wholesale-strip');
    if (!strip0 || !window.Massy || typeof window.Massy.getPrice !== 'function') return;
    if (!/You're at \d+% off/.test(strip0.textContent || '')) return;
    bbGrossBagDollars().then(function (gross) { repriceWithMassyAt(gross); });
  }
  function repriceWithMassyAt(gross){
    try {
      if (!(gross > 0)) return;
      var head = body.querySelector('[data-bb-qs-price]');
      var btnPrice = body.querySelector('[data-bb-qs-addprice]');
      var tiers = body.querySelectorAll('.bb-qs__tier[data-bb-qs-variant]');
      function paintHead(ws, retailStr){
        if (head) head.innerHTML = ws + ' <s style="opacity:.55;font-size:.8em;font-weight:400">' + retailStr + '</s>';
        if (btnPrice) btnPrice.textContent = ws;
      }
      if (tiers.length) {
        tiers.forEach(function(t){
          if (t.disabled) return;
          var retailStr = t.getAttribute('data-retail') || t.getAttribute('data-price') || '';
          var retail = parseFloat(retailStr.replace(/[^0-9.]/g, ''));
          if (!retail) return;
          Promise.resolve(window.Massy.getPrice(t.getAttribute('data-bb-qs-variant'), gross)).then(function(p){
            var n = Number(p);
            if (!isFinite(n) || n <= 0 || n >= retail) return;
            var ws = moneyFmt(n);
            t.setAttribute('data-retail', retailStr);
            t.setAttribute('data-price', ws);
            var pe = t.querySelector('.bb-qs__tierPrice');
            if (pe) pe.innerHTML = ws + ' <s style="opacity:.55">' + retailStr + '</s>';
            if (t.classList.contains('is-chosen')) paintHead(ws, retailStr);
          }).catch(function(){});
        });
        return;
      }
      var add = body.querySelector('[data-bb-qs-add]');
      var vid = add && add.getAttribute('data-variant-id');
      var retailOne = parseFloat(((head && head.textContent) || '').replace(/[^0-9.]/g, ''));
      if (!vid || !retailOne) return;
      Promise.resolve(window.Massy.getPrice(vid, gross)).then(function(p){
        var n = Number(p);
        if (!isFinite(n) || n <= 0 || n >= retailOne) return;
        paintHead(moneyFmt(n), moneyFmt(retailOne));
      }).catch(function(){});
    } catch (e) { /* retail stays */ }
  }

  function wholesale(){
    var box = body.querySelector('[data-bb-qs-wholesale]');
    if (!box) return;
    try {
      var data = massyRule();
      if (!data) return;
      var ctags = (root.getAttribute('data-bb-ctags') || '').split(',')
        .map(function(t){ return t.trim(); }).filter(Boolean);
      var eligible = data.tags.some(function(t){ return ctags.indexOf(t) > -1; });
      if (!eligible) return;
      var cids = (box.getAttribute('data-cids') || '').split(',').filter(Boolean);
      if (data.exCids.length && cids.some(function(c){ return data.exCids.indexOf(c) > -1; })) return;

      /* 2026-09-09: this table multiplies the unit price by each tier's percentage,
         so it MUST read retail. repriceWithMassy() rewrites the headline and the
         size buttons to wholesale, so read the retail we stashed on the chosen
         button (data-retail), else the struck-through retail in the headline,
         else the headline itself when no reprice has happened. Reading the plain
         headline after a reprice double-discounts every row. */
      var chosenTier = body.querySelector('.bb-qs__tier.is-chosen');
      var retailAttr = chosenTier && chosenTier.getAttribute('data-retail');
      var priceEl = body.querySelector('[data-bb-qs-price]');
      var struck = priceEl && priceEl.querySelector('s');
      var rawPrice = retailAttr || (struck ? struck.textContent : (priceEl ? priceEl.textContent : ''));
      var price = parseFloat((rawPrice || '').replace(/[^0-9.]/g, ''));
      if (!price) return;

      /* 2026-10-13 (accuracy fix C): Massy's bands overlap at their edges and
         the lower rate wins ($300.00 is still 30%, $1,000.00 still 40%), so the
         first rung reads "From" and every later rung reads "Over". No ranges,
         no dashes. Amounts always show cents: "From $150.00". */
      function tierAmt(n){
        var parts = Number(n).toFixed(2).split('.');
        return '$' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
      }
      var maxPct = 0;
      var rows = data.tiers.map(function(t, i){
        if (t.discountType !== 1) return '';           /* only percentage rules are safe to display */
        maxPct = Math.max(maxPct, t.discountValue);
        var range = (i === 0 ? 'From ' : 'Over ') + tierAmt(t.quantityFrom);
        var unit = price * (1 - t.discountValue / 100);
        return '<div class="bb-qs__wsRow"><span class="r">' + range + '</span>' +
               '<span class="p">' + moneyFmt(unit) + '</span>' +
               '<span class="c">' + t.discountValue + '% off</span></div>';
      }).join('');
      if (!rows) return;

      box.innerHTML =
        '<div class="bb-qs__wsHead"><span class="t">&#10022; Your wholesale pricing</span>' +
        '<span class="chip">Save up to ' + maxPct + '%</span></div>' +
        '<p class="bb-qs__wsSub">Based on your bag total</p>' + rows;
      box.hidden = false;
    } catch (e){ /* stays hidden */ }
  }

  /* ---- origin globe ----------------------------------------------------
     A compact, non-interactive cousin of the homepage aurora globe
     (bb-origin-globe.js): same face shading, gold origin country, glowing
     pin. NO rotation (Paul, 2026-08-20): the sphere faces the origin from
     the first frame and the only motion is a very slow zoom from continent
     to country. The sphere stays fully in frame at all times. An origin
     that matches no atlas country (e.g. "Worldwide") renders still.
     Same CDN deps as the homepage globe, loaded once and cached. */
  var D3_URL = 'https://cdn.jsdelivr.net/npm/d3@7/dist/d3.min.js';
  var TOPOJSON_URL = 'https://cdn.jsdelivr.net/npm/topojson-client@3/dist/topojson-client.min.js';
  var ATLAS_URL = 'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json';
  var scriptPromises = {}, atlasPromise = null;

  function ensureScript(src, globalKey){
    if (window[globalKey]) return Promise.resolve();
    if (scriptPromises[src]) return scriptPromises[src];
    return scriptPromises[src] = new Promise(function(resolve, reject){
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = resolve;
      s.onerror = function(){ reject(new Error('failed ' + src)); };
      document.head.appendChild(s);
    });
  }

  function loadAtlas(){
    if (atlasPromise) return atlasPromise;
    return atlasPromise = ensureScript(TOPOJSON_URL, 'topojson')
      .then(function(){ return ensureScript(D3_URL, 'd3'); })
      .then(function(){ return fetch(ATLAS_URL); })
      .then(function(r){ if(!r.ok) throw new Error('atlas ' + r.status); return r.json(); })
      .then(function(t){ return window.topojson.feature(t, t.objects.countries); });
  }

  /* metafield country names → Natural Earth atlas names */
  var GLOBE_ALIASES = {
    'united states': 'united states of america',
    'usa': 'united states of america',
    'uk': 'united kingdom',
    'dr congo': 'dem. rep. congo',
    'democratic republic of the congo': 'dem. rep. congo',
    'republic of the congo': 'congo',
    'swaziland': 'eswatini',
    'dominican republic': 'dominican rep.'
  };

  /* ---- region gazetteer -------------------------------------------------
     The country_of_origin metafield is "Region, Country", but pinning at the
     COUNTRY centroid puts New Mexico in Wyoming (the USA centroid includes
     Alaska). Region centroids for every value in the catalog, 2026-08-20.
     TWIN: this table also lives in bb-origin-map.js / bb-quickshop.js —
     keep both in sync when regions are added. Keys are normalized by
     bbNormRegion(): lowercase, diacritics stripped, trailing
     province/region/district dropped. Falls back to the country centroid
     (with a contiguous-US override) when a region is missing. */
  var BB_REGION_COORDS = {
    /* Madagascar */
    'atsimo-andrefana':{lat:-22.9,lng:44.3}, 'amboasitra':{lat:-20.53,lng:47.24},
    'alaotra-mangoro':{lat:-17.8,lng:48.4}, 'boeny':{lat:-16.3,lng:46.5},
    'bongolava':{lat:-18.8,lng:45.6}, 'mahajanga':{lat:-15.72,lng:46.32},
    'ambatondrazaka':{lat:-17.83,lng:48.42}, 'sofia':{lat:-15.5,lng:48.0},
    'vakinankaratra':{lat:-19.75,lng:46.9}, "amoron'i mania":{lat:-20.5,lng:47.2},
    'analamanga':{lat:-18.7,lng:47.5}, 'anosy':{lat:-24.8,lng:46.9},
    'betsiboka':{lat:-17.0,lng:46.8}, 'sakoany':{lat:-15.95,lng:45.95},
    'akansobe':{lat:-18.3,lng:47.1}, 'androy':{lat:-24.8,lng:45.7},
    'antsiranana':{lat:-12.3,lng:49.3}, 'atsinanana':{lat:-18.7,lng:48.9},
    'toliara':{lat:-23.35,lng:43.67},
    /* Brazil */
    'minas gerais':{lat:-18.5,lng:-44.4}, 'rio grande do sul':{lat:-29.8,lng:-53.2},
    'bahia':{lat:-12.6,lng:-41.7}, 'parana':{lat:-24.6,lng:-51.5},
    'paraiba':{lat:-7.1,lng:-36.7},
    /* Zimbabwe */
    'masvingo':{lat:-20.1,lng:30.8}, 'mashonaland west':{lat:-17.5,lng:29.9},
    'mashonaland central':{lat:-16.8,lng:31.1}, 'mashonaland east':{lat:-18.1,lng:31.8},
    'matabeleland south':{lat:-21.0,lng:29.0}, 'midlands':{lat:-19.0,lng:29.8},
    'chivhu':{lat:-19.02,lng:30.9},
    /* Zambia */
    'southern':{lat:-16.5,lng:27.0}, 'copperbelt':{lat:-13.0,lng:28.0},
    /* Peru */
    'ica':{lat:-14.1,lng:-75.6}, 'arequipa':{lat:-15.8,lng:-72.3},
    'ancash':{lat:-9.4,lng:-77.6}, 'huarochiri':{lat:-11.9,lng:-76.4},
    'junin':{lat:-11.5,lng:-75.0}, 'lima':{lat:-12.0,lng:-76.8},
    'acari':{lat:-15.43,lng:-74.62},
    /* United States */
    'arkansas':{lat:34.8,lng:-92.4}, 'arizona':{lat:34.3,lng:-111.7},
    'san carlos apache reservation, arizona':{lat:33.4,lng:-110.4},
    'utah':{lat:39.3,lng:-111.7}, 'south dakota':{lat:44.4,lng:-100.3},
    'new mexico':{lat:34.4,lng:-106.1},
    /* Namibia */
    'erongo':{lat:-21.8,lng:15.5}, 'kunene':{lat:-19.5,lng:13.8},
    'karas':{lat:-27.0,lng:17.5},
    /* South Africa */
    'northern cape':{lat:-29.5,lng:21.5}, 'limpopo':{lat:-23.8,lng:29.5},
    'mpumalanga':{lat:-25.8,lng:30.3},
    /* DR Congo + Republic of the Congo */
    'haut-lomami':{lat:-8.0,lng:25.5}, 'haut-katanga':{lat:-10.7,lng:27.5},
    'reneville':{lat:-4.3,lng:14.4},
    /* Malawi / Indonesia / China / Russia */
    'nsipe':{lat:-14.9,lng:34.75}, 'west java':{lat:-6.9,lng:107.5},
    'jiangxi':{lat:27.3,lng:115.7}, 'republic of karelia':{lat:63.5,lng:33.0},
    /* Americas */
    'artigas':{lat:-30.6,lng:-56.9}, 'boyaca':{lat:5.7,lng:-73.1},
    'salta':{lat:-24.8,lng:-65.4}, 'catamarca':{lat:-27.3,lng:-66.9},
    'rio negro':{lat:-40.4,lng:-67.2}, 'jalisco':{lat:20.5,lng:-103.6},
    'chihuahua':{lat:28.5,lng:-106.0}, 'barahona':{lat:18.2,lng:-71.1},
    'angel sandoval':{lat:-17.0,lng:-58.8}, 'quebec':{lat:52.0,lng:-71.0},
    /* Africa (rest) + Oceania */
    'hhohho':{lat:-26.0,lng:31.3}, 'huila':{lat:-14.9,lng:14.9},
    'francistown':{lat:-21.2,lng:27.5}, 'central':{lat:-21.5,lng:26.5},
    'bobonong':{lat:-21.97,lng:28.43}, 'nampula':{lat:-15.1,lng:39.0},
    'tete':{lat:-15.6,lng:32.7}, 'zambezia':{lat:-16.5,lng:37.0},
    'morogoro':{lat:-6.8,lng:37.7}, 'western australia':{lat:-25.5,lng:122.0}
  };
  /* geoCentroid of a multipolygon USA lands in the Alaska-weighted north;
     pin the contiguous states instead when no region matched */
  var BB_COUNTRY_COORDS = {
    'united states of america':{lat:39.8,lng:-98.6}
  };
  function bbNormRegion(s){
    return (s || '').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u01c1\u2016]/g, '')
      .replace(/[\u2019\u2018]/g, "'")
      .replace(/\s+(province|region|district)$/, '')
      .trim();
  }

  function mountGlobe(){
    var elm = body.querySelector('[data-bb-qs-globe]:not([data-bb-qs-globe-mounted])');
    if (!elm) return;
    elm.setAttribute('data-bb-qs-globe-mounted', '1');
    loadAtlas().then(function(topo){
      if (elm.isConnected) renderGlobe(elm, topo);
    }).catch(function(){
      var card = elm.closest('.bb-qs__globeCard');
      if (card) card.style.display = 'none';   /* CDN down: lose the globe, keep the drawer */
    });
  }

  function renderGlobe(mountEl, topo){
    var d3 = window.d3;
    /* The sphere must stay fully in frame at maximum zoom — a clipped globe
       reads as a flat map. baseR leaves the headroom the zoom spends. */
    var W = 340, PAD = 6, MAX_ZOOM = 1.42;
    var baseR = (W/2 - PAD) / MAX_ZOOM;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* "Region, Country" → country is the last comma part */
    var raw = (mountEl.getAttribute('data-origin') || '').trim();
    var parts = raw.split(',').map(function(s){ return s.trim(); }).filter(Boolean);
    var countryKey = (parts[parts.length - 1] || '').toLowerCase();
    countryKey = GLOBE_ALIASES[countryKey] || countryKey;
    var regionKey = bbNormRegion(parts.slice(0, -1).join(', '));
    var feature = null;
    topo.features.forEach(function(f){
      if ((f.properties.name || '').toLowerCase() === countryKey) feature = f;
    });
    /* region centroid first; then the country override; the atlas country
       centroid is the last resort */
    var rc = BB_REGION_COORDS[regionKey] || BB_COUNTRY_COORDS[countryKey];
    var focus = rc ? [rc.lng, rc.lat]
                   : (feature ? d3.geoCentroid(feature) : null);   /* [lon, lat] */

    /* No spinning: the globe faces the origin from the first frame. */
    var lambda = focus ? -focus[0] : -30;
    var betaNow = focus ? Math.max(-65, Math.min(65, -focus[1])) : -18;
    var zoom = 1;

    var projection = d3.geoOrthographic().scale(baseR).translate([W/2, W/2])
      .rotate([lambda, betaNow, 0]);
    var pathGen = d3.geoPath(projection);
    var graticule = d3.geoGraticule10();

    var NS = 'http://www.w3.org/2000/svg';
    function mk(name, attrs){
      var n = document.createElementNS(NS, name);
      if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
      return n;
    }

    mountEl.innerHTML = '';
    var svg = mk('svg', { viewBox: '0 0 ' + W + ' ' + W, role: 'presentation' });
    var defs = mk('defs');
    defs.innerHTML =
      '<radialGradient id="bbQsFace" cx="32%" cy="28%">' +
      '<stop offset="0%" stop-color="#24444B"/><stop offset="55%" stop-color="#142C31"/>' +
      '<stop offset="100%" stop-color="#081C1F"/></radialGradient>' +
      '<radialGradient id="bbQsPin" cx="50%" cy="50%">' +
      '<stop offset="0%" stop-color="#FFF3C8" stop-opacity="1"/>' +
      '<stop offset="50%" stop-color="#C9A14A" stop-opacity=".6"/>' +
      '<stop offset="100%" stop-color="#C9A14A" stop-opacity="0"/></radialGradient>' +
      '<filter id="bbQsGlow"><feGaussianBlur stdDeviation="2"/></filter>';
    svg.appendChild(defs);
    var face = mk('circle', { cx: W/2, cy: W/2, r: baseR, fill: 'url(#bbQsFace)' });
    svg.appendChild(face);
    var gratPath = mk('path', { fill: 'none', stroke: '#5E8A8F', 'stroke-width': 0.4, opacity: 0.22 });
    svg.appendChild(gratPath);
    var landGroup = mk('g');
    var nodes = topo.features.map(function(f){
      var isOrigin = (f === feature);
      var n = mk('path', {
        fill: isOrigin ? 'rgba(201,161,74,.38)' : 'rgba(180,210,215,.09)',
        stroke: isOrigin ? 'rgba(201,161,74,.75)' : 'rgba(180,210,215,.26)',
        'stroke-width': isOrigin ? 0.9 : 0.4
      });
      landGroup.appendChild(n);
      return { node: n, feature: f };
    });
    svg.appendChild(landGroup);
    var rim = mk('circle', { cx: W/2, cy: W/2, r: baseR, fill: 'none',
      stroke: 'rgba(74,107,79,.35)', 'stroke-width': 0.8 });
    svg.appendChild(rim);

    var pinG = null, pinParts = null;
    if (focus){
      pinG = mk('g', { opacity: 0 });
      var halo = mk('circle', { r: 13, fill: 'url(#bbQsPin)', filter: 'url(#bbQsGlow)' });
      var ring = mk('circle', { r: 6, fill: 'none', stroke: '#C9A14A', 'stroke-width': 1.1 });
      var dot  = mk('circle', { r: 2.6, fill: '#FFF3C8' });
      pinG.appendChild(halo); pinG.appendChild(ring); pinG.appendChild(dot);
      svg.appendChild(pinG);
      pinParts = [halo, ring, dot];
    }
    mountEl.appendChild(svg);

    function paint(){
      var r = baseR * zoom;
      projection.scale(r).rotate([lambda, betaNow, 0]);
      face.setAttribute('r', r);
      rim.setAttribute('r', r);
      gratPath.setAttribute('d', pathGen(graticule) || '');
      nodes.forEach(function(o){
        var d = pathGen(o.feature);
        if (d) o.node.setAttribute('d', d); else o.node.removeAttribute('d');
      });
      if (pinG && focus){
        var pt = projection(focus);
        if (!pt || isNaN(pt[0])){ pinG.style.display = 'none'; }
        else {
          pinG.style.display = '';
          pinParts.forEach(function(c){ c.setAttribute('cx', pt[0]); c.setAttribute('cy', pt[1]); });
        }
      }
    }

    if (reduced || !focus){
      /* worldwide, or reduced motion: a still globe, nothing moves */
      zoom = focus ? MAX_ZOOM : 1;
      paint();
      if (pinG) pinG.setAttribute('opacity', 1);
      return;
    }

    /* the only motion: a very slow, subtle zoom from continent to country,
       with the pin breathing in near the end */
    var t0 = performance.now(), dur = 4200, settled = false;
    function easeOut(t){ return 1 - Math.pow(1 - t, 3); }
    function settle(){
      if (settled || !mountEl.isConnected) return;
      settled = true;
      zoom = MAX_ZOOM;
      paint();
      if (pinG) pinG.setAttribute('opacity', 1);
    }
    var fly = function(now){
      if (settled || !mountEl.isConnected) return;   /* drawer closed */
      var t = Math.min(1, (now - t0) / dur), k = easeOut(t);
      zoom = 1 + (MAX_ZOOM - 1) * k;
      paint();
      if (pinG){
        var pk = Math.max(0, (t - 0.45) / 0.55);
        pinG.setAttribute('opacity', easeOut(pk));
      }
      if (t < 1) requestAnimationFrame(fly);
      else settled = true;
    };
    paint();
    requestAnimationFrame(fly);
    /* rAF is throttled or frozen in background tabs and some embedded
       webviews — never leave the globe stuck mid-zoom with no pin */
    setTimeout(settle, dur + 300);
  }

  /* ---- gallery: dots track the narrow-viewport horizontal strip ---- */
  function gallery(){ return root ? root.querySelector('[data-bb-qs-gallery]') : null; }

  function syncDots(){
    var g = gallery(); if (!g) return;
    var track = g.querySelector('[data-bb-qs-track]');
    var shot = track && track.querySelector('.bb-qs__shot');
    if (!shot) return;
    if (track.scrollWidth <= track.clientWidth + 1) return;   /* vertical column on desktop */
    var w = shot.getBoundingClientRect().width || 1;
    var i = Math.round(track.scrollLeft / w);
    g.querySelectorAll('[data-bb-qs-dot]').forEach(function(d, n){ d.classList.toggle('is-on', n === i); });
  }

  document.addEventListener('scroll', function(event){
    if (event.target && event.target.matches && event.target.matches('[data-bb-qs-track]')) syncDots();
  }, true);

  /* warm the cache on hover so the drawer is already there when it is asked for */
  document.addEventListener('pointerenter', function(event){
    var t = event.target.closest && event.target.closest('[data-bb-qs-open]');
    if (!t) return;
    var url = t.getAttribute('data-bb-qs-open');
    if (!cache[url]) load(url).catch(function(){});
  }, true);

  /* ---- add to bag: our own fetch against the cart drawer's public API,
     the same pattern the saved page uses (product-form.js is unavailable off
     product templates). One call carries the stepper quantity; Massy's fetch
     patch injects its pricing property on the way through. */
  function cartTarget(){
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function addToBag(btn){
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    var qtyIn = body.querySelector('[data-bb-qs-qtyin]');
    var qty = Math.max(1, Math.min(99, parseInt(qtyIn && qtyIn.value, 10) || 1));
    var cart = cartTarget();
    var textEl = btn.querySelector('.bb-qs__addText');
    var label = textEl ? textEl.textContent : '';
    btn.setAttribute('aria-disabled', 'true');
    if (textEl) textEl.textContent = 'Adding\u2026';
    var payload = { items: [{ id: +vid, quantity: qty }] };
    if (cart && typeof cart.getSectionsToRender === 'function'){
      payload.sections = cart.getSectionsToRender().map(function(sd){ return sd.id; });
      payload.sections_url = window.location.pathname;
    }
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function(r){ return r.json(); }).then(function(data){
      if (data.status){                                  /* sold out / limit */
        if (textEl) textEl.textContent = 'Could not add';
        setTimeout(function(){
          if (textEl) textEl.textContent = label;
          btn.removeAttribute('aria-disabled');
        }, 2400);
        return;
      }
      track('bb_quickshop_add', {
        product_handle: btn.getAttribute('data-handle') || '',
        variant_id: vid, quantity: qty
      });
      if (cart && typeof cart.renderContents === 'function'){
        cart.classList.remove('is-empty');
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        cart.renderContents(data);                       /* repaints + opens the bag */
      }
      if (textEl) textEl.textContent = label;
      btn.removeAttribute('aria-disabled');
      close();
    }).catch(function(){
      if (textEl) textEl.textContent = label;
      btn.removeAttribute('aria-disabled');
    });
  }

  document.addEventListener('click', function(event){
    var trigger = event.target.closest('[data-bb-qs-open]');
    if (trigger){
      event.preventDefault();
      open(trigger.getAttribute('data-bb-qs-open'), trigger);
      return;
    }
    if (!root || !root.classList.contains('is-open')) return;
    if (event.target.closest('.bb-qs__close') || event.target.closest('.bb-qs__scrim')){
      event.preventDefault();
      close();
      return;
    }
    if (event.target.closest('[data-bb-qs-prev]')){ goNav(-1); return; }
    if (event.target.closest('[data-bb-qs-next]')){ goNav(1); return; }
    var qbtn = event.target.closest('[data-bb-qs-minus], [data-bb-qs-plus]');
    if (qbtn){
      var qin = body.querySelector('[data-bb-qs-qtyin]');
      if (qin){
        var v = (parseInt(qin.value, 10) || 1) + (qbtn.hasAttribute('data-bb-qs-plus') ? 1 : -1);
        qin.value = Math.max(1, Math.min(99, v));
      }
      return;
    }
    var addBtn = event.target.closest('[data-bb-qs-add]');
    if (addBtn){ addToBag(addBtn); return; }
    var dot = event.target.closest('[data-bb-qs-dot]');
    if (dot){
      var g = gallery();
      var track = g.querySelector('[data-bb-qs-track]');
      var shot = track.querySelector('.bb-qs__shot');
      track.scrollLeft = (+dot.getAttribute('data-bb-qs-dot')) * shot.getBoundingClientRect().width;
      return;
    }
    var tier = event.target.closest('.bb-qs__tier');
    if (tier && !tier.disabled){
      var panel = tier.closest('.bb-qs__inner');
      panel.querySelectorAll('.bb-qs__tier').forEach(function(b){ b.classList.remove('is-chosen'); });
      tier.classList.add('is-chosen');
      var add = panel.querySelector('[data-bb-qs-add]');
      if (add) add.setAttribute('data-variant-id', tier.getAttribute('data-bb-qs-variant'));
      var price = tier.getAttribute('data-price');
      var head = panel.querySelector('[data-bb-qs-price]');
      var btnPrice = panel.querySelector('[data-bb-qs-addprice]');
      var tierRetail = tier.getAttribute('data-retail');
      if (head) {
        if (tierRetail && tierRetail !== price) {
          head.innerHTML = price + ' <s style="opacity:.55;font-size:.8em;font-weight:400">' + tierRetail + '</s>';
        } else {
          head.textContent = price;
        }
      }
      if (btnPrice) btnPrice.textContent = price;
      var scarce = panel.querySelector('[data-bb-qs-scarce]');
      if (scarce){
        var low = tier.getAttribute('data-low');
        scarce.textContent = low || '';
        scarce.classList.toggle('is-hidden', !low);
      }
      wholesale();                       /* unit prices follow the chosen tier */
      return;
    }
  });

  document.addEventListener('keydown', function(event){
    if (!root || !root.classList.contains('is-open')) return;
    if (event.key === 'Escape'){ close(true); return; }
    if ((event.key === 'ArrowLeft' || event.key === 'ArrowRight') &&
        !(event.target && /INPUT|SELECT|TEXTAREA/.test(event.target.tagName))){
      goNav(event.key === 'ArrowLeft' ? -1 : 1);
      return;
    }
    /* keep Tab inside the dialog while it is open */
    if (event.key === 'Tab'){
      var focusables = root.querySelectorAll(
        'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first){
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last){
        event.preventDefault(); first.focus();
      }
    }
  });

  /* the theme's <add-to-cart class="cart-drawer"> opens the bag itself —
     step out of its way and close the drawer behind it */
  document.addEventListener('ajaxProduct:added', function(){ close(); });
})();
